export default __webpack_public_path__ + "favicon.c3d736bd.png";